<template>
  <div class="page pink page-no-flex">
    <div class="main md-scrollbar padded w-small">
      <Register />
    </div>
  </div>
</template>
<script>
import Register from '../components/Register.vue';
import Header from "../components/common/Header.vue";
import Footer from "../components/common/Footer.vue";
export default {
  components: {
    Register, Header, Footer
  }
}
</script>